import CategoryModel from '../../../../../models/v2/category/category.model';
import { SelectMenuOptionType } from '../../../../../models/v2/general/select.model';
import { flattenCategories } from './category-picker.helpers';

// Helper to calculate category depth in hierarchy
const calculateCategoryDepth = (category: CategoryModel, allCategories: CategoryModel[]): number => {
	let depth = 0;
	let currentCategory = category;

	while (currentCategory.parentId) {
		const parent = allCategories.find((cat) => cat.id === currentCategory.parentId);
		if (!parent) break;
		depth++;
		currentCategory = parent;
	}

	return depth;
};

export const categoriesToOptions = (categories: CategoryModel[]): SelectMenuOptionType[] => {
	if (!categories || categories.length === 0) {
		return [];
	}

	const flatCategories = flattenCategories(categories);

	return flatCategories
		.filter((category: CategoryModel) => category && category.active)
		.map((category: CategoryModel) => returnMappedCategoryWithDepth(category, flatCategories));
};

export const returnMappedCategory = (category: CategoryModel): SelectMenuOptionType => {
	return {
		value: category.id,
		label: category.title,
		data: category,
	};
};

export const returnMappedCategoryWithDepth = (category: CategoryModel, allCategories: CategoryModel[]): SelectMenuOptionType => {
	const depth = calculateCategoryDepth(category, allCategories);
	return {
		value: category.id,
		label: category.title,
		data: { ...category, depth },
	};
};

export const categoriesFromOptionSelections = (selections: SelectMenuOptionType[]): CategoryModel[] => {
	return selections ? selections.map((selection: SelectMenuOptionType) => selection.data) : [];
};

export const categoryToOption = (category: CategoryModel): SelectMenuOptionType => {
	return returnMappedCategory(category);
};

export const categoriesToOptionArray = (categories: CategoryModel[]): SelectMenuOptionType[] => {
	return categories ? categories.map((category: CategoryModel) => categoryToOption(category)) : [];
};
